module.exports = __webpack_public_path__ + "media/images/icon/icon_comment-c23307eb678c9a5ada48c90a6142d2a6.png";